import { Accordion, Button, Form, ListGroup, Modal, Spinner } from "react-bootstrap";
import { DEV_SERVER } from "../../../constants/urls";
import axios from "axios";
import { useMutation } from "react-query";
import { useState } from "react";
import { toast } from "react-toastify";
import { userSignal } from "../../../signal/userSignal";
import { stateNames } from "../../../utilities/stateNames";
import Select from "react-select"
import { organisationSignal } from "../../../signal/organisationSignal";
import { productSignal } from "../../../signal/productSignal";


export default function AddProductModal(props) {

    const [product, setProduct] = useState(props?.product ? props?.product : {
        name: "",
        description: "",
        price: 0,
        tallyQty: 0,
        cashPrice: 0,
        productCode: "",
        isTaxEnabled: false,
        isVisible: true,
        taxRates: {
            CGST: 0,
            SGST: 0,
            IGST: 0
        },
        images: [],
        statePrices: {},
        stateCashPrices: {},
        category: "",
        packagingTypes: [],
        packagingTypesPrices: {},
        packagingTypesCashPrices: {},
        packagingTypesStatePrices: {},
        packagingTypesStateCashPrices: {}
    })

    const imageUploadMutation = useMutation((data) => axios.post(`${DEV_SERVER}/auth/v2/uploadMedia`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
            "Authorization": `Bearer ${userSignal.value?.token}`
        }
    }), {
        onSuccess: (data) => {
            if (data.data.status) {
                if (data.data.data?.length > 0) {
                    let images = product?.images;
                    data.data.data.map((item) => {
                        images.push(item)
                    })
                    setProduct({ ...product, images: images })
                } else {
                    toast.error("Something went wrong")
                }
            } else {
                toast.error(data.data.message)
            }
        },
        onError: (error) => {
            console.log("error ", error)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error(error.message)
            }
        }
    })

    const handleImageUpload = (e) => {
        let data = new FormData();
        for (let i = 0; i < e.target.files.length; i++) {
            data.append("media", e.target.files[i])
        }
        imageUploadMutation.mutate(data)
    }

    const addProductMutation = useMutation((body) => axios.post(`${DEV_SERVER}/product/v2`, body, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },

    }), {
        onSuccess: (data) => {
            data = data.data;
            if (data.status) {
                toast.success(data.message);
                props?.close();
                props?.refetchProducts();

                let temp = productSignal?.value;
                temp[data.data.id] = data.data;
                productSignal.value = temp;
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const handleAddProduct = async () => {

        if (product?.name === "") {
            toast.error("Name is required");
            return;
        }

        // if (product?.price === "") {
        //     toast.error("Price is required");
        //     return;
        // }

        // if (product?.images?.length === 0) {
        //     toast.error("Images are required");
        //     return;
        // }

        let flag = true;

        await new Promise((resolve, reject) => {
            Object.keys(product?.statePrices).map((item) => {
                if (product?.statePrices[item] === "") {
                    flag = false;
                    reject();
                }
            })
            resolve();
        }).catch((error) => {
            flag = false;
            console.log("error ", error)
        })

        await new Promise((resolve, reject) => {
            Object.keys(product?.packagingTypesPrices).map((item) => {
                if (product?.packagingTypesPrices[item] === "") {
                    flag = false;
                    reject();
                }
            })
            resolve();
        }).catch((error) => {
            flag = false;
            console.log("error ", error)
        })

        await new Promise((resolve, reject) => {
            Object.keys(product?.packagingTypesStatePrices).map((item) => {
                Object.keys(product?.packagingTypesStatePrices[item]).map((item1) => {
                    if (product?.packagingTypesStatePrices[item][item1] === "") {
                        flag = false;
                        reject();
                    }
                })
            })
            resolve();
        }).catch((error) => {
            flag = false;
            console.log("error ", error)
        })

        if (!flag) {
            toast.error("Price for all states is required");
            return;
        }

        addProductMutation.mutate(product);
    }

    return (
        <Modal fullscreen show={props?.show} onHide={() => props?.close()}>
            <Modal.Header closeButton>
                <Modal.Title>Add Product</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <div className="d-flex w-50 mx-auto" style={{ columnGap: "1rem" }}>
                        <Form.Group className="mb-3 col-6" controlId="formBasicName">
                            <Form.Label>Name</Form.Label>
                            <Form.Control value={product?.name} onChange={(e) => setProduct({ ...product, name: e.target.value })} type="text" placeholder="Enter name" />
                        </Form.Group>
                        <Form.Group className="mb-3 col-6" controlId="formBasicProductCode">
                            <Form.Label>Product Code</Form.Label>
                            <Form.Control value={product?.productCode} onChange={(e) => setProduct({ ...product, productCode: e.target.value })} type="text" placeholder="Enter product code" />
                        </Form.Group>

                    </div>
                    <Form.Group className="mb-3 w-50 mx-auto" controlId="formBasicDescription">
                        <Form.Label>Description</Form.Label>
                        <Form.Control value={product?.description} as={"textarea"} rows={5} cols={20} onChange={(e) => setProduct({ ...product, description: e.target.value })} type="text" placeholder="Enter description" />
                    </Form.Group>

                    <div className="d-flex w-50 mx-auto" style={{ columnGap: "1rem" }}>
                        <Form.Group className="mb-3 col-6" controlId="formBasicCategory">
                            <Form.Label>Category</Form.Label>
                            <Select
                                options={organisationSignal.value?.categories?.map((item) => ({ value: item, label: item }))}
                                onChange={(e) => setProduct({ ...product, category: e.value })}
                                value={{ value: product?.category, label: product?.category }}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3 col-6" controlId="formBasicPackgingTypes">
                            <Form.Label>Packaging Types</Form.Label>
                            <Select
                                isMulti
                                options={organisationSignal.value?.packagingTypes?.map((item) => ({ value: item, label: item }))}
                                onChange={(e) => setProduct({ ...product, packagingTypes: e.map((item) => item.value) })}
                                value={product?.packagingTypes?.map((item) => ({ value: item, label: item }))}
                            />
                        </Form.Group>

                    </div>


                    <Form.Group className="mb-3 w-50 mx-auto" controlId="formBasicIsVisible">
                        <Form.Label>Is Visible</Form.Label>
                        <Select
                            options={[{ value: true, label: "Yes" }, { value: false, label: "No" }]}
                            onChange={(e) => setProduct({ ...product, isVisible: e.value })}
                            value={{ value: product?.isVisible, label: product?.isVisible ? "Yes" : "No" }}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3 w-50 mx-auto" controlId="formBasicTallyQty">
                        <Form.Label>Available Quantity</Form.Label>
                        <Form.Control value={product?.tallyQty} onChange={(e) => setProduct({ ...product, tallyQty: parseInt(e.target.value) })} type="number" placeholder="Enter tally quantity" />
                    </Form.Group>

                    <Form.Group className="mb-3 w-50 mx-auto" controlId="formBasicPrice">
                        <Form.Label>Price</Form.Label>
                        <Form.Control value={product?.price} onChange={(e) => setProduct({ ...product, price: parseFloat(e.target.value) })} type="number" placeholder="Enter price" />
                    </Form.Group>

                    {organisationSignal.value?.isCashPriceEnabled &&
                        <Form.Group className="mb-3 w-50 mx-auto" controlId="formBasicCashPrice">
                            <Form.Label>Cash Price</Form.Label>
                            <Form.Control value={product?.cashPrice} onChange={(e) => setProduct({ ...product, cashPrice: parseFloat(e.target.value) })} type="number" placeholder="Enter cash price" />
                        </Form.Group>
                    }

                    <Form.Group className="mb-3 w-50 mx-auto" controlId="formBasicPrice">
                        <Form.Label>Is Tax Enabled</Form.Label>
                        <Select
                            options={[{ value: true, label: "Yes" }, { value: false, label: "No" }]}
                            onChange={(e) => setProduct({ ...product, isTaxEnabled: e.value })}
                            value={{ value: product?.isTaxEnabled, label: product?.isTaxEnabled ? "Yes" : "No" }}
                        />
                    </Form.Group>

                    {product?.isTaxEnabled && <Form.Group className="mb-3 w-50 mx-auto" controlId="formBasicTaxRate">
                        <Form.Label>Tax Rates (in %)</Form.Label>
                        <div className="d-flex flex-column ms-4" style={{ columnGap: "1rem" }}>
                            {Object.keys(product?.taxRates).map((item, i) => (
                                <div key={i} className="d-flex align-items-center" style={{ columnGap: "1rem" }}>
                                    <Form.Group className="mb-3 d-flex align-items-center" style={{ columnGap: "1rem" }} controlId="formBasicName">
                                        <Form.Label>{item}: </Form.Label>
                                        <Form.Control type="number" placeholder="Enter tax rate" value={product?.taxRates[item]} onChange={(e) => {
                                            let taxRates = product?.taxRates;
                                            taxRates[item] = parseFloat(e.target.value);
                                            setProduct({ ...product, taxRates: taxRates })
                                        }} />
                                    </Form.Group>
                                </div>
                            ))}
                        </div>
                    </Form.Group>}

                    <Accordion className="w-75 mx-auto">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>State wise price</Accordion.Header>
                            <Accordion.Body>
                                {Object.keys(product?.statePrices).map((item, i) =>
                                    <div key={i} className="d-flex align-items-center" style={{ columnGap: "1rem" }}>
                                        <Form.Group className="mb-3 col-5" controlId="formBasicName">
                                            <Form.Label>{"State Name"}</Form.Label>

                                            <Select
                                                options={stateNames.map((state) => ({ value: state, label: state }))}
                                                onChange={(e) => {
                                                    let statePrices = product?.statePrices;
                                                    statePrices[e.value] = product?.price;
                                                    let stateCashPrices = product?.stateCashPrices;
                                                    stateCashPrices[e.value] = product?.cashPrice;
                                                    setProduct({ ...product, statePrices: statePrices, stateCashPrices: stateCashPrices })
                                                }}
                                                value={{ value: item, label: item }}
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3 col-3" controlId="formBasicProductCode">
                                            <Form.Label>Price</Form.Label>
                                            <Form.Control type="number" placeholder="Enter price" value={product?.statePrices[item]} onChange={(e) => {
                                                let statePrices = product?.statePrices;
                                                statePrices[item] = parseFloat(e.target.value);
                                                setProduct({ ...product, statePrices: statePrices })
                                            }} />
                                        </Form.Group>

                                        {organisationSignal.value?.isCashPriceEnabled && <Form.Group className="mb-3 col-3" controlId="formBasicProductCode">
                                            <Form.Label>Cash Price</Form.Label>
                                            <Form.Control type="number" placeholder="Enter price" value={product?.stateCashPrices[item] || 0} onChange={(e) => {
                                                let stateCashPrices = product?.stateCashPrices;
                                                stateCashPrices[item] = parseFloat(e.target.value);
                                                setProduct({ ...product, stateCashPrices: stateCashPrices })
                                            }} />
                                        </Form.Group>}

                                        <i className="fa fa-trash" onClick={() => {
                                            let statePrices = product?.statePrices;
                                            delete statePrices[item];
                                            let stateCashPrices = product?.stateCashPrices;
                                            delete stateCashPrices[item];
                                            setProduct({ ...product, statePrices: statePrices, stateCashPrices: stateCashPrices })
                                        }} style={{ cursor: "pointer" }}></i>
                                    </div>
                                )}
                                <div className="d-flex">
                                    <Form.Group className="mb-3 col-6" controlId="formBasicName">
                                        <Form.Label>New State</Form.Label>

                                        <Select
                                            options={stateNames.map((state) => ({ value: state, label: state }))}
                                            onChange={(e) => {
                                                let statePrices = product?.statePrices;
                                                statePrices[e.value] = product?.price;
                                                let stateCashPrices = product?.stateCashPrices;
                                                stateCashPrices[e.value] = product?.cashPrice;
                                                setProduct({ ...product, statePrices: statePrices, stateCashPrices: stateCashPrices })
                                            }}
                                            value={{ value: "", label: "" }}
                                        />
                                    </Form.Group>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>

                    <Accordion className="w-75 mx-auto mt-3">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>Prices for Packaging Types</Accordion.Header>
                            <Accordion.Body>
                                {product?.packagingTypes?.map((item, i) =>
                                    <div className="d-flex flex-column">
                                        <h5>For {item}</h5>
                                        <div key={i} className="d-flex align-items-center" style={{ columnGap: "1rem" }}>
                                            <Form.Group className="mb-3 mt-2 col-5 d-flex align-items-center" controlId="formBasicProductCode">
                                                <Form.Label className="me-2"><h6>Price: </h6></Form.Label>
                                                <Form.Control type="number" placeholder="Enter price" value={product?.packagingTypesPrices[item] || 0} onChange={(e) => {
                                                    let packagingTypesPrices = product?.packagingTypesPrices;
                                                    packagingTypesPrices[item] = parseFloat(e.target.value);
                                                    setProduct({ ...product, packagingTypesPrices: packagingTypesPrices })
                                                }} />
                                            </Form.Group>
                                            {organisationSignal.value?.isCashPriceEnabled &&
                                                <Form.Group className="mb-3 mt-2 col-5 d-flex align-items-center" controlId="formBasicProductCode">
                                                    <Form.Label className="me-2"><h6>Cash Price: </h6></Form.Label>
                                                    <Form.Control type="number" placeholder="Enter price" value={product?.packagingTypesCashPrices ? (product?.packagingTypesCashPrices[item] || 0) : 0} onChange={(e) => {
                                                        let packagingTypesCashPrices = product?.packagingTypesCashPrices || {};
                                                        packagingTypesCashPrices[item] = parseFloat(e.target.value);
                                                        setProduct({ ...product, packagingTypesCashPrices: packagingTypesCashPrices })
                                                    }} />
                                                </Form.Group>
                                            }
                                        </div>


                                        <Accordion className="w-100 mx-auto">
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>State wise price for {item}</Accordion.Header>
                                                <Accordion.Body>
                                                    {product?.packagingTypesStatePrices[item] && Object.keys(product?.packagingTypesStatePrices[item]).map((item1, i) =>
                                                        <div key={i} className="d-flex align-items-center" style={{ columnGap: "1rem" }}>
                                                            <Form.Group className="mb-3 col-5" controlId="formBasicName">
                                                                <Form.Label>{"State Name"}</Form.Label>

                                                                <Select
                                                                    options={stateNames.map((state) => ({ value: state, label: state }))}
                                                                    onChange={(e) => {
                                                                        let statePrices = product?.packagingTypesStatePrices;
                                                                        statePrices[item][e.value] = product?.packagingTypesStatePrices[item][item1];
                                                                        let stateCashPrices = product?.packagingTypesStateCashPrices;
                                                                        stateCashPrices[item][e.value] = product?.packagingTypesStateCashPrices[item][item1];
                                                                        setProduct({ ...product, packagingTypesStatePrices: statePrices, packagingTypesStateCashPrices: stateCashPrices })
                                                                    }}
                                                                    value={{ value: item1, label: item1 }}
                                                                />
                                                            </Form.Group>
                                                            <Form.Group className="mb-3 col-3" controlId="formBasicProductCode">
                                                                <Form.Label>Price</Form.Label>
                                                                <Form.Control type="number" placeholder="Enter price" value={product?.packagingTypesStatePrices[item][item1]} onChange={(e) => {
                                                                    let statePrices = product?.packagingTypesStatePrices
                                                                    statePrices[item][item1] = parseFloat(e.target.value);
                                                                    setProduct({ ...product, packagingTypesStatePrices: statePrices })

                                                                }} />
                                                            </Form.Group>

                                                            {organisationSignal.value?.isCashPriceEnabled && <Form.Group className="mb-3 col-3" controlId="formBasicProductCode">
                                                                <Form.Label>Cash Price</Form.Label>
                                                                <Form.Control type="number" placeholder="Enter price" value={product?.packagingTypesStateCashPrices[item][item1] || 0} onChange={(e) => {
                                                                    let stateCashPrices = product?.packagingTypesStateCashPrices
                                                                    stateCashPrices[item][item1] = parseFloat(e.target.value);
                                                                    setProduct({ ...product, packagingTypesStateCashPrices: stateCashPrices })

                                                                }} />
                                                            </Form.Group>}

                                                            <i className="fa fa-trash" onClick={() => {
                                                                let statePrices = product?.packagingTypesStatePrices;
                                                                delete statePrices[item][item1];
                                                                let stateCashPrices = product?.packagingTypesStateCashPrices;
                                                                delete stateCashPrices[item][item1];
                                                                setProduct({ ...product, packagingTypesStatePrices: statePrices, packagingTypesStateCashPrices: stateCashPrices })
                                                            }} style={{ cursor: "pointer" }}></i>
                                                        </div>
                                                    )}
                                                    <div className="d-flex">
                                                        <Form.Group className="mb-3 col-6" controlId="formBasicName">
                                                            <Form.Label>New State</Form.Label>

                                                            <Select
                                                                options={stateNames.map((state) => ({ value: state, label: state }))}
                                                                onChange={(e) => {
                                                                    let statePrices = product?.packagingTypesStatePrices;
                                                                    if (!statePrices[item]) {
                                                                        statePrices[item] = {}
                                                                    }
                                                                    statePrices[item][e.value] = product?.packagingTypesPrices[item];
                                                                    let stateCashPrices = product?.packagingTypesStateCashPrices;
                                                                    if (!stateCashPrices[item]) {
                                                                        stateCashPrices[item] = {}
                                                                    }
                                                                    stateCashPrices[item][e.value] = product?.packagingTypesCashPrices[item];
                                                                    setProduct({ ...product, packagingTypesStatePrices: statePrices, packagingTypesStateCashPrices: stateCashPrices})
                                                                }}
                                                                value={{ value: "", label: "" }}
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                )}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>

                    <Form.Group className="mb-3 w-50 mx-auto mt-3" controlId="formBasicImages">
                        <Form.Label>Images</Form.Label>
                        <div className="d-flex justify-content-center align-items-center flex-wrap" style={{ columnGap: "0.5rem" }}>
                            {product?.images?.length > 0 && product?.images.map((item, i) => {
                                return <div key={i} className="mt-3" style={{ width: "50px", height: "50px", margin: "0.5rem", position: "relative" }}>
                                    <img
                                        style={{ height: "100%", width: "100%" }}
                                        className="d-block w-100"
                                        src={item.url}
                                        alt="First slide"
                                    />
                                    <span onClick={() => {
                                        let images = product?.images;
                                        images.splice(i, 1);
                                        setProduct({ ...product, images: images })
                                    }} className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                        <i style={{ cursor: "pointer" }} className="fas fa-times"></i>
                                        <span className="visually-hidden">unread messages</span>
                                    </span>
                                </div>
                            })}
                            <button disabled={imageUploadMutation.isLoading} className="btn btn-primary mt-3 d-flex justify-content-center align-items-center" style={{ width: "50px", height: "50px", margin: "0.5rem", position: "relative" }}>
                                <i className="fas fa-upload"></i>
                                <input onClick={(e) => { e.target.value = null }} onChange={(e) => handleImageUpload(e)} type="file" multiple style={{ width: "50px", height: "50px", position: "absolute", top: "0", left: "0", opacity: "0", cursor: "pointer" }} />
                            </button>
                        </div>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={addProductMutation.isLoading || imageUploadMutation.isLoading} variant="primary" onClick={() => handleAddProduct()}>
                    {(addProductMutation.isLoading || imageUploadMutation.isLoading) ? <Spinner animation="border" size="sm" /> : "Add"}
                </Button>
                <Button variant="secondary" onClick={() => props?.close()}>
                    Close
                </Button>
            </Modal.Footer>


        </Modal>
    )
}